import { useParams } from "react-router-dom";
import { HAAR_RADIUS_GEMEINDEN } from "@/data/locationsData";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

const RegionalFootball = () => {
  const { locationSlug } = useParams<{ locationSlug: string }>();
  const loc = HAAR_RADIUS_GEMEINDEN.find(g => g.slug === locationSlug) || HAAR_RADIUS_GEMEINDEN[0];

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title={`Fußball Individualtraining ${loc.name} | Einzeltraining | Valorform`}
        description={`Exklusives Fußball-Individualtraining & Athletikcoaching für Spieler aus ${loc.name}.`}
        path={`/football-training/${loc.slug}`}
      />
      <Navigation />
      <main className="container mx-auto max-w-4xl px-4 py-24 mt-10">
        <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6">
          Fußball Individualtraining in {loc.name}
        </h1>
        <p className="text-xl text-muted-foreground mb-12 leading-relaxed">
          Gewinne mehr entscheidende Zweikämpfe und sprinte deinen Gegenspielern in der Schlussphase davon. Unser maßgeschneidertes Fußball-Einzeltraining richtet sich an ambitionierte Talente und Vereinsspieler aus {loc.name}.
        </p>
        <div className="text-center bg-primary/10 p-8 rounded-xl border border-primary/20">
          <h3 className="text-2xl font-bold mb-4">Maximiere deinen Impact auf dem Spielfeld</h3>
          <a href="/" className="inline-block bg-primary text-white font-bold px-8 py-3 rounded-lg shadow-md hover:bg-primary/90 transition-colors duration-200">Einzeltraining anfragen</a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RegionalFootball;
